import { FileText } from 'lucide-react'
import { WorkReport } from '@/components/WorkReport'

export default function ReportsPage() {
  return (
    <div className="min-h-screen bg-[#F5F4F0]">
      <header className="bg-white border-b border-[#E8E7E3] sticky top-0 z-30 no-print">
        <div className="px-6 flex items-center gap-3" style={{ height: '52px' }}>
          <FileText className="w-4 h-4 text-[#6B6860]" />
          <span className="font-display text-[15px] font-bold text-[#1A1916]">Laporan Kerja</span>
        </div>
      </header>
      <main className="px-6 py-6">
        <WorkReport />
      </main>
    </div>
  )
}
